var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 73,
    viewBox: "0 0 89 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9082 37.8725V12.1781C27.9082 11.8551 28.0368 11.5445 28.2662 11.3158L34.2424 5.35697C34.4718 5.12826 34.7833 5 35.1072 5H54.4632C55.1389 5 55.686 5.54551 55.686 6.21927V37.8725H27.9082Z",
    fill: "white",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1072 5.39564V11.3328C35.1072 11.4997 34.9724 11.6342 34.805 11.6342H28.4103C28.277 11.6342 28.212 11.4704 28.3096 11.3792L34.5989 5.1762C34.791 4.9954 35.1072 5.13139 35.1072 5.39564Z",
    fill: "#77CCCD",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6113 16.3491H51.6506",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6279 16.3491H33.0522",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6113 20.9126H51.6506",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6279 20.9126H33.0522",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6113 25.4761H51.6506",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6279 25.4761H33.0522",
    stroke: "#77CCCD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9486 44.285L87.2065 20.1718C87.7419 18.9156 87.1545 17.4635 85.8945 16.9277L66.2665 8.58229C65.0217 8.05357 63.581 8.61501 63.0286 9.84537L52.2901 33.7224L76.9486 44.285Z",
    fill: "white",
    stroke: "#87A1FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4534 23.8771C83.6998 23.267 83.497 22.59 83.0025 22.2044C82.9967 21.4561 82.5441 20.7495 81.8049 20.4523C81.0749 20.1587 80.2695 20.3482 79.7446 20.868C79.731 20.861 79.7158 20.8554 79.7022 20.8499C79.2797 20.6793 78.8129 20.7925 78.5126 21.0988C77.9628 20.9017 77.3511 21.1714 77.1306 21.7166C76.9061 22.2738 77.1769 22.9086 77.7358 23.1326C77.7631 23.1436 77.7889 23.153 77.8164 23.1609L81.4835 24.6329C81.5121 24.6471 81.5424 24.6598 81.5726 24.6726C81.6029 24.6853 81.6334 24.6949 81.6653 24.7062L81.6698 24.7081C82.3851 24.9403 83.1684 24.5838 83.4534 23.8771Z",
    fill: "#DDE5FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6288 16.3669C62.8978 15.7675 63.5285 15.4417 64.1488 15.5302C64.6935 15.0163 65.5161 14.8496 66.2441 15.1755C66.9632 15.4963 67.3845 16.2056 67.3738 16.945C67.3875 16.9505 67.4026 16.9561 67.4162 16.9632C67.8316 17.1487 68.0742 17.5634 68.0614 17.99C68.5855 18.249 68.8149 18.875 68.5732 19.411C68.326 19.9591 67.6801 20.205 67.1303 19.9584C67.1047 19.9459 67.0791 19.9335 67.0536 19.9195L63.4465 18.3073C63.4161 18.2961 63.3857 18.2849 63.3556 18.2706C63.3254 18.2563 63.2968 18.2421 63.2682 18.228L63.2637 18.2261C62.6011 17.8718 62.3165 17.0611 62.6288 16.3669Z",
    fill: "#DDE5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4421 28.5045C73.8525 28.593 75.0674 27.5247 75.1557 26.1184C75.244 24.7121 74.1722 23.5003 72.7618 23.4118C71.3514 23.3232 70.1364 24.3915 70.0482 25.7978C69.9599 27.2041 71.0317 28.4159 72.4421 28.5045Z",
    fill: "#87A1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6777 37.2409C78.1834 36.1674 78.2501 34.9399 77.866 33.8165L76.7662 30.6012C76.7662 30.6012 76.178 28.5674 73.2598 29.4202L71.2786 30.3701C71.2786 30.3701 69.8124 30.9918 68.9835 29.7374L67.3003 24.7402C67.3003 24.7402 66.8185 22.7999 64.649 23.1522L57.4585 26.0443C57.4585 26.0443 53.4562 30.9775 61.2001 33.6813L75.6276 41.7157L77.6777 37.2409Z",
    fill: "#87A1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8785 48.9079C24.0957 48.9079 30.757 42.2659 30.757 34.0726C30.757 25.8793 24.0957 19.2373 15.8785 19.2373C7.66133 19.2373 1 25.8793 1 34.0726C1 42.2659 7.66133 48.9079 15.8785 48.9079Z",
    fill: "white",
    stroke: "#F79A00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6002 39.3036C12.6002 40.1288 11.5928 40.798 10.3514 40.798C9.10994 40.798 8.10254 40.1288 8.10254 39.3036C8.10254 38.4784 9.10994 37.8093 10.3514 37.8093C11.5928 37.8093 12.6002 38.4784 12.6002 39.3036ZM12.6002 39.3036V28.8386L21.5955 27.3442V37.8093M21.5955 37.8093C21.5955 38.6345 20.5881 39.3036 19.3466 39.3036C18.1052 39.3036 17.0978 38.6345 17.0978 37.8093C17.0978 36.9841 18.1052 36.3149 19.3466 36.3149C20.5881 36.3149 21.5955 36.9841 21.5955 37.8093ZM12.6002 31.8288L21.5955 30.3345",
    stroke: "#F79A00",
    strokeWidth: 2,
    strokeMiterlimit: 133.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4718 29.088C20.4672 29.2163 20.4596 29.3443 20.4506 29.4657L13.9229 30.5053V29.9953L20.4765 28.8717C20.4761 28.9404 20.4745 29.0128 20.4718 29.088Z",
    fill: "#F79A00",
    stroke: "#F79A00",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3301 37.6678C20.3305 37.6679 20.3292 37.671 20.325 37.6768C20.3276 37.6706 20.3297 37.6677 20.3301 37.6678ZM20.1893 37.7127C20.2107 37.7258 20.229 37.738 20.2446 37.7491C20.229 37.7603 20.2107 37.7724 20.1893 37.7855C19.9985 37.9022 19.6713 38.007 19.2568 38.007C18.8424 38.007 18.5152 37.9022 18.3243 37.7855C18.303 37.7724 18.2847 37.7603 18.2691 37.7491C18.2847 37.738 18.303 37.7258 18.3243 37.7127C18.5152 37.596 18.8424 37.4912 19.2568 37.4912C19.6713 37.4912 19.9985 37.596 20.1893 37.7127ZM18.1836 37.6678C18.184 37.6677 18.1861 37.6706 18.1887 37.6768C18.1845 37.671 18.1832 37.6679 18.1836 37.6678ZM18.1836 37.8304C18.1832 37.8303 18.1845 37.8272 18.1887 37.8214C18.1861 37.8276 18.184 37.8305 18.1836 37.8304ZM20.3301 37.8304C20.3297 37.8305 20.3276 37.8276 20.325 37.8214C20.3292 37.8272 20.3305 37.8303 20.3301 37.8304Z",
    fill: "#F79A00",
    stroke: "#F79A00",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4248 39.2225C11.4252 39.2226 11.4239 39.2257 11.4197 39.2315C11.4223 39.2253 11.4244 39.2224 11.4248 39.2225ZM11.2841 39.2674C11.3054 39.2805 11.3237 39.2926 11.3393 39.3038C11.3237 39.315 11.3054 39.3271 11.2841 39.3402C11.0932 39.4569 10.766 39.5617 10.3516 39.5617C9.93713 39.5617 9.60994 39.4569 9.41907 39.3402C9.39771 39.3271 9.37943 39.315 9.36382 39.3038C9.37943 39.2926 9.39771 39.2805 9.41907 39.2674C9.60994 39.1507 9.93713 39.0459 10.3516 39.0459C10.766 39.0459 11.0932 39.1507 11.2841 39.2674ZM9.27832 39.2225C9.27873 39.2224 9.28084 39.2253 9.28343 39.2315C9.2792 39.2257 9.27791 39.2226 9.27832 39.2225ZM9.27832 39.3851C9.27791 39.385 9.2792 39.3819 9.28343 39.3761C9.28084 39.3823 9.27873 39.3852 9.27832 39.3851ZM11.4248 39.3851C11.4244 39.3852 11.4223 39.3823 11.4197 39.3761C11.4239 39.3819 11.4252 39.385 11.4248 39.3851Z",
    fill: "#F79A00",
    stroke: "#F79A00",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.68 36.1028L66.8638 36.549L67.3276 36.6827C73.619 38.4966 78.2205 44.2977 78.2205 51.1742C78.2205 59.1431 72.0421 65.6655 64.2221 66.2146L64.0575 66.2261C63.7494 66.2445 63.4495 66.2568 63.151 66.2568C62.8124 66.2568 62.4739 66.2426 62.1305 66.2191L62.0964 66.2167H62.0623H18.0917H18.0549L18.0183 66.2194C17.7166 66.2416 17.4262 66.2568 17.1384 66.2568C10.9833 66.2568 5.99121 61.2621 5.99121 55.1008C5.99121 49.0831 10.7539 44.1813 16.7111 43.9565L17.3535 43.9322L17.5981 43.3377C19.2682 39.279 23.2547 36.426 27.9074 36.426C28.0622 36.426 28.2194 36.4301 28.3783 36.4373L29.0694 36.4684L29.3422 35.8327C32.4412 28.6123 39.6096 23.5596 47.9547 23.5596C56.4039 23.5596 63.6457 28.7386 66.68 36.1028Z",
    fill: "#25B161",
    stroke: "white",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6338 52.8896C73.6338 46.7236 68.9833 41.7153 63.2576 41.7153L73.6338 52.8896Z",
    fill: "#25B161"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6338 52.8896C73.6338 46.7236 68.9833 41.7153 63.2576 41.7153",
    stroke: "#EFE9FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 49.6973C15.3961 49.6973 12.1749 52.9184 12.1749 56.8807L19.3584 49.6973Z",
    fill: "#25B161"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 49.6973C15.3961 49.6973 12.1749 52.9184 12.1749 56.8807",
    stroke: "#EFE9FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageGreen);
export default __webpack_public_path__ + "static/media/StorageGreen.ccc0e4ae69a745c65aa50142b2eafd24.svg";
export { ForwardRef as ReactComponent };